<template>
  <Head title="Insights - Metric Filter List" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <metric-filter-list 
            :metrics_filters="metrics_filters"
            :data_blends="data_blends" 
            :clients="clients"
          ></metric-filter-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  metrics_filters: Array,
  data_blends: Array,
  clients: Array
});
</script>

